module.exports = __webpack_public_path__ + "9f72f4ef036d6c77fa46c4b46d2150d1.png";